<template>
  <div class="h-full flex flex-column p-16px">
    <vxe-toolbar class-name="px-8px" :loading="loading">
      <template #buttons>
        <div class="h-input-group h-input-group-auto">
          <span class="h-input-addon">期间：</span>
          <Select v-model="params.start" :datas="checkDataList" class="!w-120px" :deletable="false"/>
          <span class="h-input-addon">至</span>
          <Select v-model="params.end" :datas="checkDataList" class="!w-120px" :deletable="false"/>
          <span class="h-input-addon">类别：</span>
          <Select v-model="params.assetsTypeId" :datas="assetsTypeList" keyName="id" titleName="name" class="!w-150px"/>
          <span class="h-input-addon">编号：</span>
          <Input v-model="params.code" class="!w-80px"/>
          <span class="h-input-addon">部门：</span>
          <Select v-model="params.deptId" :datas="deptList" class="!w-130px"/>
          <Button :loading="loading" @click="doSearch" color="primary" icon="h-icon-search">查询</Button>
        </div>
      </template>
      <template #tools>
        <vxe-button @click="exportAssetsOut" icon="fa fa-download">导出</vxe-button>
        <vxe-button @click="printList" icon="fa fa-print">打印列表</vxe-button>
      </template>
    </vxe-toolbar>
    <div class="flex-1">
      <vxe-table ref="xTable" height="auto" :loading="loading" :data="dataList">
        <vxe-column title="会计期间" field="month" width="120"/>
        <vxe-column title="资产编号" field="code" width="80"/>
        <vxe-column title="资产类别" field="typeName" width="130"/>
        <vxe-column title="资产名称" field="name" width="100"/>
        <vxe-column title="规格型号" field="specification" width="120"/>
        <!-- <vxe-column title="使用部门" field="deptName" width="100"/> -->
        <vxe-column title="使用部门" field="deptName" width="100">
          <template #default="{ row }">
            {{ getDeptName(row.deptId) }}
          </template>
        </vxe-column>
        <vxe-column title="资产原值" field="originalValue" formatter="toMoney" width="120"/>
        <vxe-column title="本期折旧" field="current" formatter="toMoney" width="120"/>
        <vxe-column title="本年累计折旧" field="currentYear" formatter="toMoney" width="120"/>
        <vxe-column title="累计折旧" field="total" formatter="toMoney" width="120"/>
        <vxe-column title="减值准备" field="" width="120"/>
        <vxe-column title="资产净值" field="netValue" align="right" formatter="toMoney" width="120"/>
      </vxe-table>
    </div>
    <vxe-pager @page-change="loadList"
               v-model:current-page="pagination.page"
               v-model:page-size="pagination.pageSize"
               :total="pagination.total"
               :layouts="['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']">
      <template #left>
        <vxe-button @click="loadList()" type="text" size="mini" icon="fa fa-refresh" :loading="loading"></vxe-button>
      </template>
    </vxe-pager>
  </div>
</template>

<script>
/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2019-2020金华企客观网络科技有限公司All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : </li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2020年08月08日</li>
 * <li>@author     : ____′↘企万慧</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
export default {
  name: "AssetsDepreciationList"
}
</script>

<script setup>
import Assets from "@/api/Assets";
import {reactive, ref} from "vue";
import setting from "@/api/setting";
import AssetsType from "@/api/AssetsType";
import {useStore} from "vuex";
import manba from "manba";

const store = useStore();
const loading = ref(false);
const currentAccountDate = manba(store.state.currentAccountSets.currentAccountDate).startOf(manba.MONTH).format();
const checkDataList = ref([])
const assetsTypeList = ref([])
const dataList = ref([])
const deptList = ref([])
const pagination = ref({
  page: 1,
  pageSize: 20,
  total: 0
})
const xTable = ref(null);

const params = reactive({
  start: currentAccountDate,
  end: currentAccountDate,
  assetsTypeId: null,
  code: null,
  deptId: null,
})


const getDeptName = (deptId) =>{
  if(deptId){
    let name = deptList.value.find(item => item.key === deptId).title;
    return name ? name : '';
  }
  return '';
}

//jxd导出
const exportAssetsOut= () => {
  let $table = xTable.value;
  loading.value = true;
  Assets.Depreciation.detail(Object.assign({}, { page: 1, pageSize: 1000000 }, params))
      .then(({data: {rows, recordCount}}) => {
    if (rows && rows.length) {
      rows.forEach(row => {
        row['netValue'] = row.originalValue - row.total;
      })
    }
    // dataList.value = rows;
    // pagination.value.total = recordCount;
    let processedData = rows;
        $table.exportData({
          filename: `固定资产列表`,
          type: 'csv',
          isHeader: true,
          isFooter: true,
          data: processedData,
        });
  }).finally(() => loading.value = false)
}

const printList=()=>{
  const $table = xTable.value
  if ($table) {
    $table.print({
      // sheetName: '固定资产列表',
      // // 打印样式设置
      // style: printStyle,
      // 打印指定列
    })
  }
}


setting.accountingCategoryDetails.loadAuxiliaryAccountingDataByName(['DEPARTMENT']).then(({data}) => {
  deptList.value = data['DEPARTMENT'].map(val => {
    return {
      key: val.id,
      accountingCategoryId: val.accountingCategoryId,
      title: val.name
    }
  });
})
AssetsType.list().then(({data}) => {
  assetsTypeList.value = data || [];
})

Assets.checkDate().then(({data}) => {
  params.start = data[0].key;
  params.end = data[0].key;
  checkDataList.value = data;
  loadList();
})


const loadList = () => {
  console.log(params.end)
  loading.value = true;
  Assets.Depreciation.detail(Object.assign({}, pagination.value, params))
      .then(({data: {rows, recordCount}}) => {
        if (rows && rows.length) {
          rows.forEach(row => {
            row['netValue'] = row.originalValue - row.total;
          })
        }
        dataList.value = rows;
        pagination.value.total = recordCount;
        console.log(params.end)
      }).finally(() => loading.value = false)
}
// loadList();

const doSearch = () => {
  pagination.value.page = 1;
  loadList();
}
</script>
